module.exports = __webpack_public_path__ + "47ac407041cc36757bad81e7fd687a2a.png";